module.exports = __webpack_public_path__ + "img/maps-and-flags.fe8fc3de.svg";